var e = () => (r) => Array.from(new Set(r));
export {
  e as createProps
};
